export default __webpack_public_path__ + "static/media/atoms-logo-white.51835177.svg";